import { api } from "@/lib/api";
import { toast } from "sonner";
import { getErrorMessage } from "@/lib/errors";

/** Open a server-generated PDF in a new tab (ready to print or save). */
export async function openPdf(path, params) {
  const tab = window.open("", "_blank");
  try {
    const res = await api.get(path, { params, responseType: "blob" });
    const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
    if (tab) tab.location.href = url;
    else window.location.href = url;
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (err) {
    if (tab) tab.close();
    let message = getErrorMessage(err);
    if (err?.response?.data instanceof Blob) {
      try { message = JSON.parse(await err.response.data.text()).detail || message; } catch { /* keep generic message */ }
    }
    toast.error(message);
  }
}
